<script setup>
  import { computed } from 'vue'
  import { useStormStore } from "@/stores/StormStore";

  import { useSheetController } from '@/composables/useSheetsController';

  import MapButtonSidebar from "@/components/MapButtonSidebar.vue";
  import Icon from "@/components/icons/Icon.vue";

  const stormStore = useStormStore();

  const hasSelectedStorm = computed(() => stormStore.visibleStorms.has(stormStore.selectedStorm.id));
  const activeStorms = computed(() => stormStore.activeStorms.length > 0);
  const additionalStormCount = computed(() => {
    return stormStore.plotType === 'cone'
    ? stormStore.conePlots.filter(storm => storm.id !== stormStore.selectedStorm.id && stormStore.visibleStorms.has(storm.id)).length
    : stormStore.spaghettiPlots.filter(storm => storm.id !== stormStore.selectedStorm.id && stormStore.visibleStorms.has(storm.id)).length;
  });
  const showAdditionalStormCount = computed(() => additionalStormCount.value > 0);
  const stormName = computed(() => {
    return !activeStorms.value
      ? 'No Active Storms'
      : !hasSelectedStorm.value
      ? 'No Storm Selected'
      : stormStore.selectedStorm.status.stormfullname
  });

  function handleClick() {
    useSheetController.toggleSheet('config', 'storm-selection');
  }  

</script>

<template>
  <div
    class="jwx-map__storm-header jwx-map-block jwx-map-block--transparent-border"
    data-map="jwx-map-name"
  >
    <div class="jwx-v-map-storm-block jwx-map-block__content">
      <button
        @click.prevent="handleClick"
        class="jwx-map-name jwx-v-map-storm-block__button jwx-button-control jwx-button-control--text"
      >
        <h2 class="jwx-v-map-storm-block__name">{{ stormName }}<span v-if="showAdditionalStormCount" class="jwx-map-name__chip">+{{ additionalStormCount }}</span></h2>
        <p v-if="activeStorms && stormStore.selectedStorm?.advisory && hasSelectedStorm" class="jwx-v-map-storm-block__advisory-time">{{ stormStore.selectedStorm.advisory.localtimestring }}</p>       
      </button>
      <MapButtonSidebar
        v-if="activeStorms && stormStore.selectedStorm?.advisory && hasSelectedStorm"
        class="jwx-v-map-storm-block__advisory-button jwx-button-control--primary" 
        type="storm" 
        content="storm-advisory"
        accessibleLabel="Storm Advisory"
      >
        <Icon name="wind-warning" class="jwx-button-control__icon" />  
      </MapButtonSidebar>
    </div>
  </div>  
</template>

<style lang="scss">
  .jwx-v-map-storm-block {
    width: 100%;
  }

.jwx-v-map-storm-block__button {
  display: flex;
  flex-direction: column;
  padding: .325rem var(--jwx-block-spacing-md) .325rem var(--jwx-block-spacing) ;
  align-items: flex-start;
  justify-content: center;
}

.jwx-v-map-storm-block__name {
  font-weight: 600;
}

.jwx-v-map-storm-block__advisory-time {
  font-size: .875rem;
}  

.jwx-v-map-storm-block__advisory-button {
  position: relative;
  z-index: 1;
}

.jwx-v-map-storm-block__advisory-button.selected::before,
.jwx-v-map-storm-block__advisory-button:hover::before {
  opacity: 0;
}

.jwx-v-map-storm-block__advisory-button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 1.5rem;
  background-color: var(--jwx-button-border-color);
  transform: translateY(-50%);
  opacity: 1;
  z-index: 0;
  transition: opacity 200ms ease-in-out;
}  
</style>